import { Record } from 'immutable';

const keys: Fields = {
  isInfoModalOpen: false,
  langKey: '',
  langKeyHeader: '',
  closeButtonLangKey: '',
  onAfterClose: undefined,
};

interface Fields {
  isInfoModalOpen: boolean;
  langKey: string;
  langKeyHeader: string;
  closeButtonLangKey: string;
  onAfterClose?(): void;
}

export default class InfoModalRecord extends Record<Fields>(keys) {}
